import Heading from "./heading";
import Body from "./body";
import Item from "./item";
import { Suptitle, Title } from "./texts";
import ShowcaseRoot from "./showcase";

const ShowcaseUI = Object.assign(ShowcaseRoot, {
  Heading,
  Body,
  Item,
  Title,
  Suptitle
});

export default ShowcaseUI
